import { appConfig } from '../../../config/app-config';
import { STORAGE_KEYS } from '../../../shared/utils/storage';
import { CartView } from '../types/cartTypes';

const defaultLocale = appConfig.defaults.locale;

/**
 * Resolves the display name for a product or line item based on locale.
 */
export const getProductName = (
  item: { name?: Record<string, string> | string },
  locale: string = defaultLocale
): string => {
  if (!item.name) return 'Product';
  
  if (typeof item.name === 'object') {
    const nameObj = item.name as Record<string, string>;
    return (
      nameObj[locale] || 
      nameObj['en'] || 
      (Object.values(nameObj)[0] as string) || 
      'Product'
    );
  }
  
  return (item.name as string) || 'Product';
};

/**
 * Resolves the currency to be used for display, prioritizing context, session, then cart data.
 */
export const resolveCartCurrency = (
  cart: CartView | null,
  contextCurrency?: string
): string => {
  return (
    contextCurrency || 
    sessionStorage.getItem(STORAGE_KEYS.CURRENCY) || 
    cart?.currency || 
    'USD'
  );
};

/**
 * Formats a numeric amount as currency using the specified locale.
 */
export const formatCurrency = (
  amount: number,
  currency: string,
  locale: string = 'en'
): string => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  });
  return formatter.format(amount);
};
